// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // url: "http://localhost/drone_stream/",
  url: "http://live.thinkaerial.com/api/",
  stream_url: "http://3.108.196.179:8000/live/",
  brodcasr_url: "rtmp://3.108.196.179:3000/live/"
};

/*
http://3.109.194.206/
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
